import { HttpTransport } from './HttpTransport';
import { FetchNetworkAdapter } from './adapters/FetchNetworkAdapter';
import { BrowserSessionAdapter } from './adapters/BrowserSessionAdapter';

export * from './types';
export * from './ports';
export * from './adapters/FetchNetworkAdapter';
export * from './adapters/InMemoryNetworkAdapter';
export * from './adapters/BrowserSessionAdapter';
export * from './HttpTransport';

// Default singleton adapters
export const defaultSessionAdapter = new BrowserSessionAdapter();
export const defaultNetworkAdapter = new FetchNetworkAdapter();

// Default singleton transport instance for production
export const httpTransport = new HttpTransport({
  networkPort: defaultNetworkAdapter,
  sessionPort: defaultSessionAdapter,
});

export default httpTransport;
